import React from 'react';

function FooterComponent(props) {
  return (
    <div className='forgot-password-block'>
      <span className='globalize' data-locale-key='FORGOT_USERNAME_PASSWORD'>
        Forgot Your <a id='reset_password' href={props.urls.lostPasswordUri} target='_parent'>Password</a> or <a id='reset_username' href={props.urls.lostUsernameUri} target='_parent'>Username</a>?
      </span><br />
      <span className='globalize' data-locale-key='DONT_HAVE_ACCOUNT'>Don&apos;t have a Splunk Account? <a id='signup-button' href={props.urls.createAccount} className='create-account-btn' onContextMenu={props.onContextMenu}>Create your free account today.</a></span><br />
      <span className='globalize' data-locale-key='TRYING_ACCESS_PARTNER_PORTAL'>Trying to access the Splunk <a id='partner_portal' href={props.urls.partnerPortal} target='_parent' onContextMenu={props.onContextMenu}>Partner Portal</a>?</span>
    </div>
  )
}

export default FooterComponent